const Helpers = require('../helpers')
const scrollListener = require('../modules/module-scroll-handler')
const AppSandbox = require('../modules/module-app-sandbox')

var AppCore = function () {
  // registered components
  this.components = {}
  // initialised components
  this.instances = {}

  this.incrementedId = 1

  this.pubSub = {}
}

AppCore.prototype.init = function () {
  // initialize the components
  this.initializeComponents()

  // add some basic application functionality

  // listen for resizes
  var onResize = function () {
    this.publish('window/resize', Helpers.getViewportDimension())
  }
  window.addEventListener('resize', Helpers.throttle(onResize.bind(this), 100))
  window.addEventListener('orientationchange', Helpers.throttle(onResize.bind(this), 100))

  // listen for scroll
  var onScroll = function (scroll) {
    this.publish('window/scroll', scroll)
  }
  var scroller = new scrollListener(onScroll.bind(this))
}

AppCore.prototype.registerComponent = function (name, selector, fn) {
  var component = {
    fn: fn
  }

  if (selector) component['selector'] = selector
  if (this.components[name]) console.warn('RegisterComponent encountered the registration of a duplicate: ' + name)
  this.components[name] = component
}

/**
 * Initialize the components and check if they aren't initiated already
 * If a parentElement is given only the components which are children of the parent element
 * are initialuzed
 * @return {[type]} [description]
 */
AppCore.prototype.initializeComponents = function (parentElement) {
  var _this = this

  for (var componentName in this.components) {
    this.initializeComponent(componentName, parentElement)
  }
}

/**
 * Initializes a specific component.
 * If a parent element is given only initialize the component if the elements
 * are childs of the parent element
 *
 * @param  {[type]} componentName [description]
 * @param  {[type]} parentElement [description]
 * @return {[type]}               [description]
 */
AppCore.prototype.initializeComponent = function (componentName, parentElement) {
  if (!componentName) return
  var component = this.components[componentName]
  var elements = document.querySelectorAll(component.selector)
  // if there are elements for this component, create the instances entry
  if (elements.length <= 0) return

  if (!this.instances[componentName]) this.instances[componentName] = {}

  // walk through all elements
  for (var i = 0; i < elements.length; i++) {
    var el = elements[i]

    // if a parent element is set, check if the element is contained
    // in the parent if not continue to the next element
    if (parentElement && !parentElement.contains(el)) {
      continue
    }

    // start the initalization process
    // check if the element has an id
    if (!el.__componentId) el.__componentId = this.incrementedId++

    // check if this component is already initiated
    if (!this.instances[componentName][el.__componentId]) this.instances[componentName][el.__componentId] = {}

    // return if the app is already initiated
    if (this.instances[componentName][el.__componentId].initiated) return

    // initialize a un-initiated component and send over the sandbox
    this.instances[componentName][el.__componentId]['instance'] = new component.fn(new AppSandbox(this), el)

    this.instances[componentName][el.__componentId].initiated = true
    this.instances[componentName][el.__componentId].el = el

    this.instances[componentName][el.__componentId]['instance'].init()
  }
}

/** Deinitializes all components nested inside the given element */
AppCore.prototype.deInitializeElementComponents = function (parentElement) {
  if (!parentElement) {
    return
  }

  for (var componentName in this.components) {
    var component = this.components[componentName]

    // check if there might be instances of this type nested inside the parentelement or the parentelement is of the type
    if (parentElement.querySelectorAll(component.selector).length > 0 || parentElement.classList.contains(component.selector)) {
      this.deInitializeComponent(componentName, parentElement)
    }
  }
}

// deinitializes all instances contained in or being the given element
AppCore.prototype.deInitializeElementInstances = function (element) {
  if (!element) return

  for (var componentName in this.instances) {
    var component = this.instances[componentName]

    for (var instanceIndex in component) {
      var instance = component[instanceIndex]

            // if the instance element equals the element or the instance.el is a child of element
      if (element.contains(instance.el) || element === instance.el) {
        this.deInitializeInstance(instance.instance)
        delete this.instances[componentName][instanceIndex]
      }
    }

    // if after deinitializing instances the component doesn't have any
    // instances left deinitialize the complete component
    if (Object.keys(component).length === 0) {
      this.deInitializeComponent(componentName)
    }
  }
}

// DeInitialize an instance
AppCore.prototype.deInitializeInstance = function (instance) {
  instance.destroy() // call the destroy function on the component
  // delete instance;
}

// DeInitialize a component and all of its instances
AppCore.prototype.deInitializeComponent = function (componentName) {
  var element = element || false
  for (var componentInstanceIndex in this.instances[componentName]) {
    var instance = this.instances[componentName][componentInstanceIndex]

    if (instance.initiated) {
      this.deInitializeInstance(instance.instance)
      delete this.instances[componentName][componentInstanceIndex]
    }
  }

  delete this.instances[componentName]
}

AppCore.prototype.resetComponent = function (componentName) {
    // first deinitialize the component
  this.deInitializeComponent(componentName)

    // initialize the component
  this.initializeComponent(componentName)
}

AppCore.prototype.publish = function (message, args) {
    // return early if no-one is listening
  if (!this.pubSub[message]) {
    return
  }

  try {
    var i

    for (i = 0; i < this.pubSub[message].length; i++) {
      if (typeof args === 'undefined') { args = [] }
      if (!(args instanceof Array)) {
        args = [args]
      }
      this.pubSub[message][i].apply(this, args)
    };
  } catch (err) {
  }
}

AppCore.prototype.subscribe = function (message, callback) {
  if (!this.pubSub[message]) {
    this.pubSub[message] = []
  }
  this.pubSub[message].push(callback)
  return [message, callback]
}

AppCore.prototype.unsubscribe = function (message, callback) {
    // return early if no-one is listening
  if (!this.pubSub[message]) {
    return
  }

  for (i = 0; i < this.pubSub[message].length; i++) {
    var registration = this.pubSub[message][i]

        // if the registered subscription is found remove it
    if (registration === callback) {
      this.pubSub[message].splice(i, 1)
    }
  };
}

module.exports = AppCore



// WEBPACK FOOTER //
// ./assets/js/modules/module-app-core.js